<template>
  <el-tabs v-model="activeName" @tab-remove="removeTab">
    <el-tab-pane label="待审批" name="list">
      <List ref="list" :operateBtn="operateBtn" />
    </el-tab-pane>
    <el-tab-pane label="审批记录" name="history">
      <History ref="history" :removeTab="removeTab" />
    </el-tab-pane>
    <el-tab-pane
      v-if="detailPage"
      label="审批寻样单"
      name="detail"
      closable
    >
      <Bill ref="detail" :removeTab="removeTab" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import List from './List';
import Bill from './Bill';
import History from './History';

export default {
  name: 'outside-approval',
  components: {
    List,
    Bill,
    History
  },
  data() {
    return {
      activeName: 'list',
      historyPage: false,
      detailPage: false,
    };
  },
  watch: {
    activeName(val) {
      val !== 'detail' && this.$refs[val].getList();
    },
  },
  methods: {
    removeTab(val, name) {
      this[`${val}Page`] = false;
      this.activeName = name ? name : 'list';
      this.$refs[this.activeName].getList();
    },
    operateBtn(val, data) {
      this.activeName = val;
      this[`${val}Page`] = true;
      this.$nextTick(() => {
        this.$refs[val].getDetail(data);
      });
    },
  },
};
</script>